import { DOMAIN_EXPRESSION_REGEX } from 'constants/regex'

export const getSecureCookieName = (name: string) => {
  return `${process.env.NODE_ENV === 'production' ? '__Host-' : ''}${name}`
}

export const getRootDomain = (host: string) => {
  if (host === 'localhost') {
    return 'localhost'
  }
  const rootDomain = host.match(DOMAIN_EXPRESSION_REGEX)

  if (rootDomain) {
    return rootDomain[1]
  }
}
